import { DatePipe } from '@angular/common';
import {
  Component,

  Inject,

  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiInsightResponse, AttributeValues, EVRangeData, ModelOutput } from 'src/app/model';
import { ServicecallService, GeneralService } from 'src/app/services';
import { StatusCard } from '../trip-segment-popover/trip-segment-popover.component';
import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';

@Component({
  selector: 'app-ice-optimization-summary',
  templateUrl: './ice-optimization-summary.component.html',
  styleUrl: './ice-optimization-summary.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class IceOptimizationSummaryComponent implements OnInit {

  popOverData: EVRangeData = this.initializeDefaultData();
  tripOptimizationData: ModelOutput;
  private _tenantConfig: any;
  currentTripScore = 0.0;
  maxScore = 10;
  maxRange: string;
  options: any;
  lastTripChange: string;
  efficiencyGain: number;
  scoreDiff: number;
  currentTripPosition: 5;
  currentTripIncluded: boolean = false;
  trips: any[] = [];
  optimizationTips: any;
  selectedTagIndex: number = 0;
  //Attribute details (from config)
  statusData: StatusCard[] = [
    { id: 1, value: null, label: 'Harsh Brakes', type: 'brake', attribute: "Harsh Brakes" },
    { id: 2, value: null, label: 'Harsh Acceleration', type: 'brake', attribute: "Harsh Acceleration" },
    { id: 3, value: null, label: 'Overspeed', type: 'brake', attribute: "Overspeed" },
    { id: 4, value: null, label: 'Idle time', type: 'brake', attribute: "Idle time" },
    { id: 5, value: 92, label: 'Coolant Temp', type: 'temperature', unit: '°C', attribute: "battery_temp" },
    { id: 6, value: 105, label: 'Oil Temp', type: 'temperature', unit: '°C', attribute: "motor_temp" },
    { id: 7, value: 88, label: 'Trans Temp', type: 'temperature', unit: '°C', attribute: "inverter_temp" },
    { id: 8, value: 32, label: 'Ambient Temp', type: 'temperature', unit: '°C', attribute: "ambient_temp" },
  ];
  optimizationTripsAttributes: { attrName: string, name: string, icon?: string }[] = [
    { attrName: "Mobile Phone Usage", name: "mobile_phone_usage", icon: null },
    { attrName: "Seat Belt Violation", name: "seatbelt_violation", icon: null },
    { attrName: "Harsh Acceleration", name: "HarshAcceleration", icon: null },
  ];
  optimizationTipsFeedbackAttributes: { attrName: string, name: string, icon?: string }[] = [
    { attrName: "Harsh Acceleration", name: "HarshAcceleration", icon: null },
    { attrName: "Harsh Braking", name: "HarshBraking", icon: null }];
  optimizationTipFeedback: any[] = [];
  segmentStartLocation: string;
  segmentEndLocation: string;

  //Subscriptions
  private _tripSegmentSubscription: Subscription;
  private _getTripDetailsSubscription: Subscription;
  private _trackEntitySubscription: Subscription;
  private _tripPerformanceSubscription: Subscription;
  private _tripScoreSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ServicecallService,
    private _datePipe: DatePipe,
    private _generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this._tenantConfig = this._apiService?.getConfiguration('tenantGenericConfig') ? this._apiService?.getConfiguration('tenantGenericConfig') : null;
    this.maxScore = this._apiService.getConfiguration('iceOptimizationSummaryConfigs')?.prescriptiveInsights?.maxScore ?? 10;
    this.statusData = this._apiService.getConfiguration('iceOptimizationSummaryConfigs')?.prescriptiveInsights?.statusData ?? [];
    this.optimizationTripsAttributes = this._apiService.getConfiguration('iceOptimizationSummaryConfigs')?.prescriptiveInsights?.optimizationTipsAttributes ?? [];
    this.optimizationTipsFeedbackAttributes = this._apiService.getConfiguration('iceOptimizationSummaryConfigs')?.prescriptiveInsights?.optimizationTipsFeedbackAttributes ?? [];
    if (this.data?.selectedTripSegmentData) {
      this._loadDataForTripSegments();
    } else {
      this.loadTripOptimizationData();
      this.getTripPerformanceScore();
    }
    if (this.data?.tile1?.segmentStartLocation?.lat && this.data?.tile1?.segmentStartLocation?.long) {
      this._getLocationFromCoordinates(this.data?.tile1?.segmentStartLocation?.lat, this.data?.tile1?.segmentStartLocation?.long, 'start')
    }
    if (this.data?.tile1?.segmentEndLocation?.lat && this.data?.tile1?.segmentEndLocation?.long) {
      this._getLocationFromCoordinates(this.data?.tile1?.segmentEndLocation?.lat, this.data?.tile1?.segmentEndLocation?.long, 'end')
    }
  }

  ngOnDestroy(): void {
    this._getTripDetailsSubscription?.unsubscribe();
    this._trackEntitySubscription?.unsubscribe();
    this._tripSegmentSubscription?.unsubscribe();
    this._tripPerformanceSubscription?.unsubscribe();
    this._tripScoreSubscription?.unsubscribe();
  }

  /**
   * Loads data for trip segments
   */
  private _loadDataForTripSegments() {
    this.tripOptimizationData = JSON.parse(JSON.stringify(this.data?.selectedTripSegmentData?.modelOutput));
    this.optimizationTips = [...(this.tripOptimizationData?.optimizationTips || [])];
    this.optimizationTipFeedback = this.optimizationTips?.filter(item => !item?.tags);
    this.tripOptimizationData?.calculations ? this.tripOptimizationData.calculations.possibleRange = Number(this.tripOptimizationData?.calculations?.possibleRange)?.toFixed(2) : '';
    this.tripOptimizationData.optimizationTips = this.optimizationTips?.filter(item => item?.tags?.includes('safety'));
    this.tripOptimizationData?.calculations ? this.maxRange = Number(this.tripOptimizationData?.calculations?.maxRange)?.toFixed(2) : null;
    this.setDonutChartData(this.maxScore, this.tripOptimizationData?.summary?.score);
    this.setAttributesData();
  }


  /**
 * Initialize default data structure (keeps tripInfo intact)
 */
  private initializeDefaultData(): EVRangeData {
    return {
      tripInfo: {
        tripId: this.data?.tile1?.tripId ?? 'NA',
        vehicleId: this.data?.tile1?.entityName ?? 'NA',
        startLocation: this.data?.tile1?.startLocation ?? 'NA',
        endLocation: this.data?.tile1?.endLocation ?? 'NA',
        startTime: this.data?.tile1?.tripStartDate ?? 'NA',
        endTime: this.data?.tile1?.tripEndDate ?? 'NA',
        distance: this.calculateDistance(this.data?.tile1?.distanceTravelled),
        duration: this.data?.tile1?.timeTaken ?? 0,
        mileage: this.data?.tile1?.mileage ? this.data?.tile1?.mileage?.toFixed(2) : 0,
        totalFuelConsumed: this.data?.tile1?.totalFuelConsumed ? this.data?.tile1?.totalFuelConsumed?.toFixed(2) : 0,
        avgSpeed: this.calculateSpeed(this.data?.tile1?.avgSpeed),
        maxSpeed: this.calculateSpeed(this.data?.tile1?.topSpeed),
        remainingRange: this.data?.tile1?.possibleRange ?? 191,
        tags: this.data?.tile1?.tags,
        imageUrl: this.data?.tile1?.imageUrl,
        tripType: this.data?.tile1?.tripType
      },
      maximumRange: this.data?.tile1?.maxRange ?? 262,
      optimizationTips: [],
      drivingConditions: [],
    };
  }

  onTagSelection(index: number, tag: string) {
    this.selectedTagIndex = index;
    this.tripOptimizationData.optimizationTips = this.optimizationTips?.filter(item => item?.tags?.includes(tag));
  }

  setAttributesData() {
    if (Array.isArray(this.statusData)) {
      this.statusData?.forEach((statusItem, index) => {
        if(index < 4){
        const matchedAttribute = this.optimizationTips?.find(
          (attr) => attr?.attributeName?.trim()?.toLowerCase() === statusItem?.attribute?.trim()?.toLowerCase()
        );
        if (matchedAttribute) {
          statusItem.value = matchedAttribute?.observedTimestamps ? matchedAttribute?.observedTimestamps?.length : 0;
        }
      }
    });
    }
  }

  /**
 * Loads trip optimization insights data
 */
  private loadTripOptimizationData(): void {
    let configStartDate = null;
    let configEndDate = null;
    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this._apiService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if (this.data?.tile1?.selectedDate) {
        startTime = this.data?.tile1?.selectedDate?.['start'];
        endTime = this.data?.tile1?.selectedDate?.['end'];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.data?.tile1?.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.data?.tile1?.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    const reqPayload = {
      entityId: this.data?.tile1?.entityId,
      // from: this._datePipe.transform(this.data?.tile1?.aggregateDate?.from ?? ((!this.data?.tile1?.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.data?.tile1?.aggregateDate?.to ?? ((!this.data?.tile1?.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      limit: 1,
      type: "PrescriptiveInsights_Trip",
      ...(this.data?.tile1?.tripId && { tripId: this.data?.tile1?.tripId })
    }
    this._tripSegmentSubscription = this._apiService.getTripSegments(reqPayload).subscribe({
      next: (result: ApiInsightResponse[]) => {
        this.tripOptimizationData = JSON.parse(JSON.stringify(result?.[0]?.modelOutput));
        if (this.tripOptimizationData) {
          this.optimizationTips = [...(this.tripOptimizationData?.optimizationTips || [])];
          this.optimizationTipFeedback = this.optimizationTips?.filter(item => !item?.tags);
          this.tripOptimizationData?.calculations ? this.tripOptimizationData.calculations.possibleRange = Number(this.tripOptimizationData?.calculations?.possibleRange)?.toFixed(2) : '';
          this.tripOptimizationData.optimizationTips = this.optimizationTips?.filter(item => item?.tags?.includes('safety'));
          this.tripOptimizationData?.calculations ? this.maxRange = Number(this.tripOptimizationData?.calculations?.maxRange)?.toFixed(2) : null;
          this.setDonutChartData(this.maxScore, this.tripOptimizationData?.summary?.score);
          this.calculateTripPerformance(result?.[0]?.dataFrom);
          this.getCurrentTripScore();
          this.setAttributesData();
        }
      }, error: () => {
        this.tripOptimizationData = null;
      }
    })
  }

  /**
 * Gets trip performance score
 */
  getTripPerformanceScore() {
    const reqPayload = {
      entityId: this.data?.tile1?.entityId,
      type: "PrescriptiveInsights_Trip",
      count: 3
    }
    this._tripPerformanceSubscription = this._apiService.getTripPerformaceScore(reqPayload).subscribe({
      next: (result: any) => {
        this.trips = [...result];
        if (this.trips?.some(item => item.tripId === this.data?.tile1?.tripId)) {
          this.currentTripIncluded = true;
        } else {
          this.currentTripIncluded = false;
        }
      }, error: () => {
        this.trips = [];
      }
    })
  }


  /**
 * Formats trip id
 * @param tripId 
 * @returns trip id 
 */
  formatTripId(tripId: string): string {
    if (!tripId) return '--';
    const start = tripId.slice(0, 5);
    const end = tripId.slice(-5);
    return `${start}...${end}`;
  }

  /**
 * Sets donut chart data for Trip Performance
 * @param maxScore
 * @param currentScore
 */
  setDonutChartData(maxScore: number, currentScore: number) {
    this.options = {
      series: {
        name: 'Trip Performance',
        type: 'pie',
        radius: ['80%', '95%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        roundCap: true,
        label: {
          show: false,
          position: 'center',
        },
        tooltip: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: currentScore === 0 ?
          [{
            value: currentScore,
            name: 'Current Score',
            itemStyle: { color: 'rgba(229, 231, 235, 1)', borderRadius: 10 },
          }] :
          [
            {
              value: currentScore,
              name: 'Current Score',
              itemStyle: { color: 'rgba(0, 210, 255, 1)', borderRadius: 10 },
            },
            {
              value: maxScore - currentScore,
              name: 'Remaining Score',
              itemStyle: { color: 'rgba(229, 231, 235, 1)' },
            },
          ],
      },
      legend: {
        selectedMode: false,
        show: false,
      },
      graphic: {
        type: 'group',
        left: 'center',
        top: 'center',
        children: [
          {
            type: 'text',
            left: 'center',
            top: -10,
            style: {
              text: currentScore,
              fontFamily: 'Inter',
              fontSize: 26,
              fontWeight: 'bold',
              fill: 'rgba(14, 192, 230, 1)',
            },
          },
          {
            type: 'text',
            left: 'center',
            top: 20,
            style: {
              text: 'out of ' + this.maxScore,
              fontFamily: 'Inter',
              fontSize: 8.71,
              fontWeight: 'normal',
              fill: 'rgba(156, 163, 175, 1)',
            },
          },
        ],
      },
      grid: {
        top: '0%',
        left: '0%',
        right: '0%',
        bottom: '0%',
      },
    };
  }

  /**
 * Calculates trip performance
 * @param fromDate 
 */
  calculateTripPerformance(fromDate: string) {
    const prevTripToDate = new Date(new Date(fromDate).getTime() - 1000); //Subtracting 1sec ,100ms = 1sec

    const reqPayload: any = {
      entityId: this.data?.tile1?.entityId,
      to: this._datePipe.transform(prevTripToDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      type: "PrescriptiveInsights_Trip",
      limit: 1,
    }
    this._tripSegmentSubscription = this._apiService.getTripSegments(reqPayload).subscribe({
      next: (result: any) => {
        if (result?.length) {
          this.scoreDiff = Number((this.tripOptimizationData?.summary?.score - result?.[0]?.modelOutput?.summary?.score)?.toFixed(2));
          const effGain = Number(((Number(this.tripOptimizationData?.calculations?.rangeImprovement) / Number(result?.[0]?.modelOutput?.calculations?.rangeImprovement)) * 100)?.toFixed(2));
          this.efficiencyGain = isFinite(effGain) ? effGain : null;
        }
      }, error: () => {
        this.scoreDiff = null;
        this.efficiencyGain = null;
      }
    })
  }

  /**
   * Gets current trip score
   */
  getCurrentTripScore() {
    const reqPayload: any = {
      entityId: this.data?.tile1?.entityId,
      ...(this.data?.tile1?.tripId && { tripId: this.data?.tile1?.tripId })
    }
    this._tripScoreSubscription = this._apiService.getCurrentTripPosition(reqPayload).subscribe({
      next: (result: any) => {
        this.currentTripPosition = result?.rank ?? 5;
      }, error: () => {
        this.currentTripPosition = 5;
      }
    })
  }

  /**
 * Helper method to calculate distance
 */
  private calculateDistance(distance: number | undefined): string | number {
    if (distance == null) return 'NA';
    return (distance)?.toFixed(2);
  }
  /**
   * Helper method to calculate speed
   */
  private calculateSpeed(speed: number | undefined): string | number {
    if (speed == null) return 'NA';
    if (speed === 0) return 0;
    return speed.toFixed(2);
  }

  /**
* Gets optimization attributes name
* @param attr 
* @returns  
*/
  getOptimizationAttributesName(attr: string) {
    return this.optimizationTripsAttributes?.find(item => item.name === attr)?.attrName;
  }

  /**
   * Gets optimization feedback name
   * @param attr 
   * @returns 
   */
  getOptimizationFeedbackName
    (attr: string) {
    return this.optimizationTipsFeedbackAttributes?.find(item => item.name === attr)?.attrName;
  }

  /**
   * 
   * @param selectedTagIndex 
   * @returns 
   */
  getScore(selectedTagIndex: number) {
    switch (selectedTagIndex) {
      case 0:
        return this.tripOptimizationData?.summary?.safety;
      case 1:
        return this.tripOptimizationData?.summary?.economy;
      case 2:
        return this.tripOptimizationData?.summary?.comfort;
      default:
        return 0;
    }
  }

  trackByFn(index: number, item: StatusCard): number {
    return item.id;
  }

  /**
* Gets location from coordinates
* @param latitude
* @param longitude
* @param locationType
* @returns location from coordinates
*/
  public async _getLocationFromCoordinates(
    latitude: number,
    longitude: number,
    type: string
  ): Promise<any> {
    try {
      const response = await fetch(
        `${ApiConstants?.HERE_REVERSE_GEOCODE_URL}?at=${latitude},${longitude}&apiKey=${this._tenantConfig?.hereApiKey}&lang=en-US`
      );
      const data = await response?.json();
      const loc = data?.items?.[0]?.address?.label;
      if (type === 'start') {
        this.segmentStartLocation = loc;
      } else {
        this.segmentEndLocation = loc;
      }
    } catch (error) {
      console.error('Error in reverse geocoding:', error);
      this.segmentStartLocation = null;
      this.segmentEndLocation = null;
    }
  }
}